import { Task } from "../../../../models/Task"
import { CheckListToTasks, TasksState, TaskState } from "../tasksReducer"
import { GetTasksForDocumentAdditionalData } from "./getTasksForDocument"

export const ADD_TASKS = "ADD_TASKS"

export interface AddTasksAction {
    type: string
    result: Task[]
}
export interface setTasksAfterResponseAction {
    type: string
    result: Task[]
    additionalData: GetTasksForDocumentAdditionalData
}

export const addTasksAction = (data: Task[]): AddTasksAction => ({
    type: ADD_TASKS,
    result: data
})

export const addTasks = (state: TasksState, newTasks: Task[]) => {
    const newChecklistsState: CheckListToTasks = {
        ...state.data
    }

    newTasks.forEach(newTask => {
        const newTaskState: TaskState = {
            isUpdating: false,
            isDeleting: false,
            item: newTask
        }
        let newChecklistTasks = [newTaskState]
        const tasksInChecklist = newChecklistsState[newTask.checklistUid]
        if (tasksInChecklist) {
            const taskExists = tasksInChecklist.tasks.find(x => x.item.taskId === newTask.taskId)
            if (taskExists) {
                newChecklistTasks = tasksInChecklist.tasks.map(x => x.item.taskId === newTask.taskId ? newTaskState : x)
            } else {
                newChecklistTasks = [...tasksInChecklist.tasks, { isUpdating: false, isDeleting: false, item: newTask }]
            }
        }

        newChecklistsState[newTask.checklistUid] = {
            isFetching: false,
            isAdding: false,
            tasks: newChecklistTasks
        }
    })

    return {
        data: {
            ...newChecklistsState
        }
    }
}
export const setTasksAfterFetch = (state: TasksState, newTasks: Task[], uids: string[]) => {
    const newChecklistsState: CheckListToTasks = {
        ...state.data
    }    

    const checklistUids = !!uids?.length ? uids : Array.from(new Set(newTasks.map(t => t.checklistUid)))

    for (const uid of checklistUids) {
        const tasks = (newTasks
            .filter(x => x.checklistUid === uid)
            .sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime())
            .map(x => ({item: x, isDeleting: false, isUpdating: false }))) as TaskState[]
        
        newChecklistsState[uid] = {
            isFetching: false,
            isAdding: false,
            tasks
        }
    }

    return {
        data: {
            ...newChecklistsState
        }
    }
}